import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import * as Library from "../../../utils/Library";
import more_soon from "../../../assets/images/more_soon.png";
import Solid from "../../../assets/images/Solid.png";
import LabelIcon from "../../../assets/images/label-icon.svg";
import Loader from "../../../assets/images/ExplorePage/Loader.svg";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import LayoutContext from "../../../contexts/LayoutContext";
import BOImagePage from "../BOImage/BOImagePage";
import BOPicsPage from "../BOPics/Index";
import StandardsContext from "../../../contexts/StandardsContext";
import logGA4Event from "../../../utils/firebase/analytics";
import PageNotFound from "../PageNotFound";
import AppContext from "../../../contexts/AppContext";
import { getCookie, storeImageDetails } from "../../../utils/helperFunctions";
import botagCloseBtn from "../../../assets/images/botagCloseBtn.png";
import BrandFilter from "../../common/mainApp/BrandFilter";

const StyledPage = styled.div`
    &.FeedPageContainer {
        display: block;
        position: relative;
        width: 100%;
        flex-shrink: 1;
        padding: 30px 24px 0 24px;
        box-sizing: border-box;
    }
    &.mobile-skeleton {
        padding: 0px 16px 0 16px !important;
    }
    .allfeedLogos {
        display: inline-flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        width: 100%;
        flex-shrink: 0;
        gap: 12px;
        padding-bottom: 14px;
        height: 54px;
    }

    .allfeedLogos::-webkit-scrollbar {
        height: 6px;
    }

    .allfeedLogos .feedIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 107px;
        height: 50px;
        border: 2px solid #383838;
        border-radius: 10px;
        font-size: 20px;
        font-weight: 200;
        cursor: pointer;
        padding: 0px 6px;
        flex-shrink: 0;
        position: relative;

        transition: border-color 0.5s;
    }

    .allfeedLogos .feedIcon img {
        width: 100%;
        height: 79%;
        object-fit: contain;
        flex-shrink: 1;
    }

    .allfeedLogos .feedIcon.active {
        border-color: #f7665f;
    }

    .allfeedLogos .feedIcon:hover {
        border-color: #f7665f;
    }

    img.MuiImageListItem-img.sublogoMain {
        height: 42px;
        width: 143px;
        position: absolute;
        bottom: 5px;
        right: 5px;
        padding: 5px 5px 1px 10px;
        object-fit: contain;
    }
    .product-count {
        height: 34px;
        position: absolute;
        bottom: 10px;
        left: 15px;
        width: 116px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .image-text {
        display: flex;
        gap: 5px;
        justify-content: space-between;
        align-items: center;
    }
    .product-count-no {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: OpenSans-Regular, sans-serif;
        font-size: 14.4px;
        line-height: 24px;
        font-weight: 400;
    }
    .MasonryContainer {
        overflow: scroll;
        height: calc(100dvh - 170px);
    }

    .MasonryContainer::-webkit-scrollbar {
        width: 8px; /* For Chrome, Safari, and Opera */
    }

    .MasonryContainer::-webkit-scrollbar-track {
        background: #000000; /* For Chrome, Safari, and Opera */
        padding-left: 2px; /* Add padding-left */
    }

    .MasonryContainer::-webkit-scrollbar-thumb {
        background-color: #3e3e3e; /* For Chrome, Safari, and Opera */
        border-radius: 10px; /* For Chrome, Safari, and Opera */
    }
    .FeedPageContainer.pad-container {
        padding: 0px !important;
    }
    .feed-image-wrapper {
        display: inline-block;
        position: relative;
        flex-direction: column;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        gap: 9px;
        display: flex;
        width: 100%;
        height: 100%;
    }
    .feed-image-wrapper-new {
        position: relative;
    }
    img.sublogoMain {
        position: absolute;
        height: 42px;
        width: 143px;
        position: absolute;
        bottom: 5px;
        right: 5px;
        padding: 5px 5px 1px 10px;
        object-fit: contain;
    }
    .css-1dpizkf-MuiMasonry-root {
        width: auto !important;
    }
    .feed-image {
        width: 100%;
        object-fit: cover;
        max-height: 100%;
        height: 600px !important;
        //opacity: 0;
        //transform: translateY(20px);
        //transition: opacity 0.5s ease-out, transform 0.5s ease-out;
    }
    .feed-image-wrapper-new-main {
        animation: fadeIn 1s ease-in-out;
    }
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    .spinner-img {
        animation: spin 1s linear infinite;
    }
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
    .feed-image-gradient {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40%; /* adjust the height to your liking */
        background: linear-gradient(to right bottom, rgb(0 0 0 / 0%) 0%, rgb(0 0 0 / 0%) 50%, rgb(0 0 0 / 50%) 100%);
    }
    @keyframes pulse-white {
        0% {
            transform: scale(1.2);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
        }

        100% {
            transform: scale(0.9);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        }
    }
    .beacons {
        display: flex;
        flex-direction: column;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        gap: 10px;
        position: absolute;
        user-select: none;
        touch-action: none;
        cursor: pointer;
    }
    .beacon-main-div {
        position: relative;
        background-color: rgba(0, 0, 0, 0.3);
        height: 40px;
        width: 40px;
        border-radius: 50%;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        animation: 1.5s ease 0s infinite normal none running pulse-white;
    }
    .beacon-product-name {
        background-color: rgba(16, 20, 27, 0.3);
        border-radius: 20px;
        color: rgb(255, 255, 255);
        padding: 8px 15px;
        position: absolute;
        top: 45px;
        white-space: nowrap;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    @media only screen and (max-width: 992px) {
        .feed-image {
            height: 563px !important;
        }
    }
`;

export default function FeedPage() {
    /* #region STATES */

    const boxRef = useRef(null);
    const targetImageRef = useRef([]);
    const { brandID: paramBrandOurID, BOImageID: paramBOImageID, GTINourID: paramGTINourID } = useParams();
    const {
        setShowRightSidebar,
        setShowRightUserLocationPanel,
        setShowFooter,
        setShowHeader,
        showBOImagePageID,
        setShowBOImagePageID,
        windowWidth,
        isMobile,
        setHomeLogo,
        setFeedLogo,
        showBOPicpageID,
        setShowBOPicpageID,
        setShowYourAccountPannel,
        setShowLoginForm,
        setShowUserLoginRegisterPopup,
        setShowRightMyOrdersDetailsPanel,
        footerLogoClicked,
        setFooterLogoClicked,
        setShowFilterBox,
        selectedGender,
        selectedType,
        setSelectedType,
        setSearchText,
        setShowImageType,
        setShowGenderFilter,
        setShowAgeGroupFilter,
        setShowColorFilter,
        setShowBrandFilter,
        setShowProductType,
        setShowProductCategory,
        setShowDeliveryFilter
    } = React.useContext(LayoutContext);
    const { setErrorDialogShow, setErrorDialogTitle, setErrorDialogMessage, setErrorDialogConfirmText, setErrorDialogCancelText } =
        React.useContext(StandardsContext);
    const {
        setSelectedBOImageData,
        setBOTagsList,
        selectedBrandID,
        setSelectedBrandID,
        boImageIsLoading,
        setSelectedBotag,
        setSelectedBotagStoreDetails,
        setSelectedHomePageBotagId
    } = React.useContext(AppContext);
    const [activeTab, setActiveTab] = useState("Global");
    const PROFILE_VAR = "?profile";
    const [firstTimeLoad, setFirstTimeLoad] = useState(true);
    const [allFeedLoading, setAllFeedLoading] = useState(false);
    const [skeletonLoading, setSkeletonLoding] = useState(true);
    const [allBrandData, setAllBrandData] = useState([]);
    const [allFeedData, setAllFeedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [brokenURL, setBrokenURL] = useState(false);
    const storedData = JSON.parse(getCookie("recentlyViewedImages")) || [];
    const [isRecentBtnClicked, setIsRecentBtnClicked] = useState(false);
    const location = useLocation();
    const isProfilePanel = location?.search === PROFILE_VAR;
    const [beacon, setBeacon] = useState({ state: false, id: "" });
    const navigate = useNavigate();
    const query = new URLSearchParams(location.search);
    const showOrder = query.get("showOrder") === "true";
    const orderNumber = query.get("orderNumber");
    const orderID = query.get("orderID");
    const [onHover, setOnHover] = useState({
        state: false,
        id: ""
    });
    const [isShowCloseBtn, setIsShowCloseBtn] = useState({ state: false, id: "" });
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        if (isProfilePanel) {
            setTimeout(() => {
                if (localStorage.getItem("isLoggedIn")) {
                    setShowYourAccountPannel(true);
                    navigate("/explore");
                } else {
                    setShowLoginForm(true);
                    setShowUserLoginRegisterPopup(true);
                }
            }, 0);
        }
    }, [isProfilePanel]);
    useEffect(() => {
        if (showOrder && orderNumber && orderID) {
            setTimeout(() => {
                setShowRightMyOrdersDetailsPanel({
                    orderID: orderID,
                    isOpen: true
                });
            }, 0);
        }
    }, []);
    useEffect(() => {
        if (showBOImagePageID || showBOPicpageID) return;

        setShowRightSidebar(true);
        setShowRightUserLocationPanel(false);
        setShowFilterBox(false);
        setShowHeader(true);
        setHomeLogo(false);
        setFeedLogo(true);
        setSearchText("");
        setShowImageType(false);
        setShowGenderFilter(false);
        setShowAgeGroupFilter(false);
        setShowColorFilter(false);
        setShowBrandFilter(false);
        setShowProductType(false);
        setShowProductCategory(false);
        setShowDeliveryFilter(false);
    }, [FeedPage]);

    useEffect(() => {
        if (showBOImagePageID || showBOPicpageID) onPrepareForShowBOImagePage();
        else onPrepareForShowFeedPage();
    }, [showBOImagePageID, showBOPicpageID]);

    useEffect(() => {
        loadMoreIfAtBottom();

        const box = boxRef.current;
        if (box && !allFeedLoading) {
            box.addEventListener("scroll", loadMoreIfAtBottom);
        }

        return () => {
            box?.removeEventListener("scroll", loadMoreIfAtBottom);
        };
    }, [
        allBrandData,
        allFeedData,
        boxRef,
        allFeedLoading,
        currentPage,
        totalPages,
        firstTimeLoad,
        showBOImagePageID,
        boxRef?.current?.clientHeight
    ]);

    useEffect(() => {
        setAllFeedData([]);
        setSkeletonLoding(true);
        if (isRecentBtnClicked && activeTab === "History") {
            getFeedRequest(storedData, 1, true);
        } else if (activeTab === "Global") {
            getFeedRequest("", 1);
        } else {
            getFeedRequest(selectedBrandID, 1);
        }
    }, [selectedBrandID, selectedGender, selectedType, activeTab]);

    useEffect(() => {
        if (!allBrandData?.length || !paramBrandOurID) return;

        const filteredBrands = allBrandData.filter(item => item.ourID === paramBrandOurID);
        if (!filteredBrands.length) {
            setErrorDialogTitle("Error showing brand BOimages");
            setErrorDialogMessage(`Brand with ID ${paramBrandOurID} not found.`);
            setErrorDialogConfirmText("OK");
            setErrorDialogCancelText("Cancel");
            setErrorDialogShow(true);
            return;
        } else if (allBrandData?.length !== filteredBrands.length) setAllBrandData(filteredBrands);
    }, [paramBrandOurID, allBrandData]);

    useEffect(() => {
        if (paramBOImageID) setShowBOImagePageID(paramBOImageID);
    }, [paramBOImageID]);

    useEffect(() => {
        if (paramGTINourID) {
            setShowBOPicpageID(paramGTINourID);
        } else {
            setShowBOPicpageID("");
        }
    }, [paramGTINourID]);

    /* #endregion */

    /* #region METHODS */
    const loadMoreIfAtBottom = () => {
        if (showBOImagePageID || showBOPicpageID) {
            return;
        }
        const box = boxRef.current;
        if (!box) return;

        const { scrollHeight, clientHeight, scrollTop } = box;
        const isAtEightyPercent = scrollTop + clientHeight >= scrollHeight - 50;
        if (isAtEightyPercent && !allFeedLoading) {
            if (currentPage < totalPages || firstTimeLoad) {
                setFirstTimeLoad(false);
                setSkeletonLoding(true);
                if (isRecentBtnClicked) {
                    getFeedRequest(storedData, currentPage + 1, true);
                } else {
                    getFeedRequest(selectedBrandID, currentPage + 1);
                }
                setCurrentPage(prev => prev + 1);
            }
        }
    };

    // example payload for getAllBOpics2 and getAllBOimages2
    // const payloadExample = {
    //     brandIDs: ["66b09097f146ecc3fdf1df5d", "64d89e21943c94b93975cc7c"], //les deux and somsoe
    //     genders: "Male",
    //     productTypes: ["shirt"],
    //     colorCodes: [
    //         {
    //             red: 75,
    //             green: 87,
    //             blue: 75
    //         }
    //     ],

    //     ageGroups: ["All"],
    //     page: page || 1,
    //     limit: limit
    // };

    const getFeedRequest = async (selectedBrandID, page, isRecentImages) => {
        const ourIDs = Array.isArray(selectedBrandID) ? selectedBrandID.map(item => item.ourID) : [selectedBrandID];
        logGA4Event("Feed_Loading");
        const limit = 15; //Math.floor(Math.random() * 6) + 15; // Random limit between 15 and 20
        await Library.makePostRequest(
            selectedType === "Posts" ? "getAllBOimages2" : "getAllBOpics2",
            {
                [isRecentImages ? "BOimagesIDs" : "brandID"]: ourIDs,
                page: page || 1,
                limit: limit,
                type: (selectedBrandID || isRecentImages) && "2",
                genders: selectedGender
            },
            false,
            setAllFeedLoading
        ).then(res => {
            if (res.data.status === 200) {
                setSkeletonLoding(false); // Hide skeleton after data is loaded
                const shuffledData = res.data.data.data.sort(() => Math.random() - 0.5); // Shuffle the data
                if (res.data.data.currentPage === 1) {
                    setAllFeedData(shuffledData);
                } else {
                    const newData = [...allFeedData, ...shuffledData];
                    setAllFeedData(newData);
                }

                if (paramBrandOurID) {
                    const id = res?.data?.data?.brandData?.find(item => item.ourID === paramBrandOurID)?._id;

                    if (id && id !== selectedBrandID) {
                        setSelectedBrandID(id);
                        getFeedRequest(id, 1);
                        return;
                    }
                }
                logGA4Event("Feed_Shown");
                setAllBrandData(res?.data?.data?.brandData);
                setCurrentPage(page);
                setTotalPages(res?.data?.data?.totalPages);
            }
        });
    };

    // When we are about to show the BOImage page, we can prepare states for it.
    const onPrepareForShowBOImagePage = () => {
        //console.log("onPrepareForShowBOImagePage");
        setShowFooter(true);
        setHomeLogo(false);
        setFeedLogo(false);

        //Cleaning up states to avoid bugs
        setSelectedBotag(null);
        setSelectedBotagStoreDetails(null);
    };

    // When we are about to enter feed or exit the BOImage page, we can clean up or prepare states.
    const onPrepareForShowFeedPage = () => {
        setShowFooter(false);
        setSelectedBOImageData(null);
        setBOTagsList([]);
        setSelectedBotag(null);
    };
    /* #endregion */
    return (
        <StyledPage
            className={`FeedPageContainer ${isMobile && boImageIsLoading ? "mobile-skeleton" : ""} ${
                (showBOImagePageID || showBOPicpageID) && !boImageIsLoading ? "pad-container" : ""
            }`}>
            {showBOImagePageID && !showBOPicpageID && !brokenURL && <BOImagePage setBrokenURL={setBrokenURL} />}
            {!showBOImagePageID && showBOPicpageID && !brokenURL && <BOPicsPage setBrokenURL={setBrokenURL} />}
            {brokenURL && <PageNotFound />}
            <div style={{ display: showBOImagePageID || showBOPicpageID ? "none" : "block" }}>
                {/*<AllFeedBrands
                    allBrandData={allBrandData}
                    feedCurrentSelectedbrandID={selectedBrandID}
                    paramBrandOurID={paramBrandOurID}
                    setSelectedBrandID={setSelectedBrandID}
                    setSkeletonLoding={setSkeletonLoding}
                    storedData={storedData}
                    getFeedRequest={getFeedRequest}
                    setIsRecentBtnClicked={setIsRecentBtnClicked}
                    footerLogoClicked={footerLogoClicked}
                    setFooterLogoClicked={setFooterLogoClicked}
                />*/}
                <BrandFilter
                    setSkeletonLoding={setSkeletonLoding}
                    setSelectedBrandID={setSelectedBrandID}
                    setIsRecentBtnClicked={setIsRecentBtnClicked}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />

                <MasonryImageList
                    allFeedData={allFeedData}
                    boxRef={boxRef}
                    width={windowWidth}
                    setShowBOImagePageID={setShowBOImagePageID}
                    setFeedLogo={setFeedLogo}
                    targetImageRef={targetImageRef}
                    setBeacon={setBeacon}
                    beacon={beacon}
                    setSelectedHomePageBotagId={setSelectedHomePageBotagId}
                    isMobile={isMobile}
                    onHover={onHover}
                    setOnHover={setOnHover}
                    isShowCloseBtn={isShowCloseBtn}
                    setIsShowCloseBtn={setIsShowCloseBtn}
                    skeletonLoading={skeletonLoading}
                    selectedType={selectedType}
                    setShowBOPicpageID={setShowBOPicpageID}
                />
            </div>
        </StyledPage>
    );
}

/* #region SMALL COMPONENTS */
const AllFeedBrands = ({
    allBrandData,
    feedCurrentSelectedbrandID,
    paramBrandOurID,
    setSelectedBrandID,
    setSkeletonLoding,
    storedData,
    getFeedRequest,
    setIsRecentBtnClicked,
    footerLogoClicked,
    setFooterLogoClicked
}) => {
    const [lastClickedButton, setLastClickedButton] = useState(feedCurrentSelectedbrandID ? "" : "all");
    useEffect(() => {
        if (feedCurrentSelectedbrandID && feedCurrentSelectedbrandID !== "-") {
            setLastClickedButton("");
        } else if (feedCurrentSelectedbrandID === "-") {
            setLastClickedButton("recentlyViewed");
        } else {
            setLastClickedButton("all");
        }
    }, [feedCurrentSelectedbrandID]);
    return (
        <div className="allfeedLogos">
            {allBrandData?.length > 1 && (
                <AllBtn
                    active={lastClickedButton === "all"}
                    setSelectedBrandID={id => {
                        setSelectedBrandID(id);
                        setLastClickedButton("all");
                    }}
                    setSkeletonLoding={setSkeletonLoding}
                    setIsRecentBtnClicked={setIsRecentBtnClicked}
                    isShow={lastClickedButton === "recentlyViewed" || lastClickedButton === "all"}
                />
            )}
            {footerLogoClicked &&
                allBrandData
                    ?.filter(item => feedCurrentSelectedbrandID === item?._id)
                    .map((item, index) => (
                        <div
                            key={index}
                            className={"feedIcon active"}
                            onClick={() => {
                                // no need for the if condition here, as we've already filtered the items
                                setSelectedBrandID(item?._id);
                                setSkeletonLoding(true);
                                setLastClickedButton(""); // Reset last clicked button when selecting a brand
                                setIsRecentBtnClicked(false);
                            }}>
                            <img src={item?.logo} alt={item?.ourID} />
                        </div>
                    ))}
            {storedData?.length ? (
                <RecentlyViewedBtn
                    active={lastClickedButton === "recentlyViewed"}
                    setSelectedBrandID={id => {
                        setSelectedBrandID(id);
                        setLastClickedButton("recentlyViewed");
                    }}
                    setSkeletonLoding={setSkeletonLoding}
                    getFeedRequest={getFeedRequest}
                    storedData={storedData}
                    setIsRecentBtnClicked={setIsRecentBtnClicked}
                    isShow={lastClickedButton === "recentlyViewed" || lastClickedButton === "all"}
                />
            ) : null}
            {allBrandData?.map((item, index) => (
                <div
                    key={index}
                    className={`feedIcon ${feedCurrentSelectedbrandID === item?._id ? "active" : ""}`}
                    onClick={() => {
                        // no need for the if condition here, as we've already filtered the items
                        setSelectedBrandID(item?._id);
                        setSkeletonLoding(true);
                        setLastClickedButton(""); // Reset last clicked button when selecting a brand
                        setIsRecentBtnClicked(false);
                        setFooterLogoClicked(false);
                    }}
                    style={
                        footerLogoClicked && feedCurrentSelectedbrandID === item?._id
                            ? {
                                  display: "none"
                              }
                            : {}
                    }>
                    <img src={item?.logo} alt={item?.ourID} />
                </div>
            ))}

            {!paramBrandOurID && <MoreSoonBtn isShow={lastClickedButton === "recentlyViewed" || lastClickedButton === "all"} />}
        </div>
    );
};

const AllBtn = ({ active, setSelectedBrandID, setSkeletonLoding, setIsRecentBtnClicked, isShow }) => {
    return (
        <div
            className={`feedIcon ${active ? "active" : ""}`}
            style={{ cursor: "pointer", width: "50px" }}
            onClick={() => {
                if (!active) {
                    setSelectedBrandID("");
                    setSkeletonLoding(true);
                    setIsRecentBtnClicked(false);
                }
            }}>
            <div
                style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#FFFFFF",
                    display: "flex",
                    textAlign: "center"
                }}>
                All
            </div>
        </div>
    );
};

const MoreSoonBtn = ({ isShow }) => {
    return (
        <div className="feedIcon" style={{ cursor: "default", borderColor: "#383838" }}>
            <img src={more_soon} alt={""} style={{ width: "16px", height: "16px" }} />
            &nbsp;
            <div
                style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#FFFFFF",
                    display: "flex",
                    textAlign: "center"
                }}>
                More soon
            </div>
        </div>
    );
};

const MasonryImageList = ({
    allFeedData,
    boxRef,
    width,
    setShowBOImagePageID,
    setFeedLogo,
    targetImageRef,
    setBeacon,
    beacon,
    setSelectedHomePageBotagId,
    isMobile,
    setOnHover,
    onHover,
    isShowCloseBtn,
    setIsShowCloseBtn,
    skeletonLoading,
    selectedType,
    setShowBOPicpageID
}) => {
    const calculateMasonryCols = () => {
        if (width < 600) return 1;
        else if (width <= 1000) return 2;
        else if (width < 1280) return 3;
        else if (width <= 1850) return 4;
        else if (width <= 1920) return 5;
        else return Math.floor((width * 4) / 1920);
    };

    const handleImageLoad = index => {
        if (targetImageRef.current[index] && targetImageRef.current[index].current) {
            targetImageRef.current[index].current.classList.add("visible");
        }
    };

    return (
        <Box className="MasonryContainer main-masonry" ref={boxRef}>
            <ImageList variant="standard" cols={calculateMasonryCols()} gap={"5px"} style={{ marginTop: "0" }}>
                {allFeedData.map((item, index) => {
                    if (!targetImageRef.current[index]) {
                        targetImageRef.current[index] = React.createRef();
                    }
                    return (
                        <ImageListItem
                            key={item?.ourID}
                            style={{ cursor: "pointer" }}
                            className="feed-image-wrapper-new-main"
                            onMouseEnter={() => {
                                !isMobile &&
                                    setBeacon({
                                        state: true,
                                        id: item?.ourID
                                    });
                            }}
                            onMouseLeave={() => {
                                !isMobile &&
                                    setBeacon({
                                        state: false,
                                        id: item?.ourID
                                    });
                            }}
                            onClick={() => {
                                const timeStamp = new Date().toISOString();
                                storeImageDetails(item?.ourID, timeStamp);
                                setFeedLogo(false);
                                if (selectedType === "Posts") {
                                    setShowBOImagePageID(item?.ourID);
                                } else {
                                    setShowBOPicpageID(item?.ourID);
                                }
                                setIsShowCloseBtn({ state: false, id: "" });
                            }}>
                            <div className="feed-image-wrapper">
                                <img
                                    src={`${item?.imageURL}`}
                                    srcSet={`${item?.imageURL}`}
                                    alt={item?.labelBrandID}
                                    loading="lazy"
                                    style={{ minHeight: "200px", borderRadius: "0px" }}
                                    className="feed-image"
                                    ref={targetImageRef.current[index]}
                                    onLoad={() => handleImageLoad(index)}
                                />
                                {beacon?.state &&
                                    beacon?.id === item?.ourID &&
                                    item?.BOtags?.map(i => {
                                        return (
                                            <Beacon
                                                i={i}
                                                item={item}
                                                targetImageRef={targetImageRef.current[index]}
                                                setSelectedHomePageBotagId={setSelectedHomePageBotagId}
                                                setIsShowCloseBtn={setIsShowCloseBtn}
                                                selectedType={selectedType}
                                                setShowBOPicpageID={setShowBOPicpageID}
                                            />
                                        );
                                    })}
                                <div className="feed-image-gradient" />
                            </div>
                            {isMobile && isShowCloseBtn?.state && isShowCloseBtn?.id === item?.ourID && (
                                <div
                                    style={{
                                        position: "absolute",
                                        zIndex: 5,
                                        top: "25px",
                                        left: "25px"
                                    }}
                                    onClick={e => {
                                        e.stopPropagation();
                                        setBeacon({
                                            state: false,
                                            id: ""
                                        });
                                        setOnHover({
                                            state: false,
                                            id: ""
                                        });

                                        setIsShowCloseBtn(false);
                                    }}>
                                    <img src={botagCloseBtn} alt="" height={"50px"} width={"50px"} />
                                </div>
                            )}
                            {!isShowCloseBtn?.state && (
                                <div
                                    className="product-count"
                                    onClick={e => {
                                        e.stopPropagation();
                                        if (isMobile) {
                                            setBeacon({
                                                state: true,
                                                id: item?.ourID
                                            });

                                            setOnHover({
                                                state: true,
                                                id: item?.ourID
                                            });
                                            setIsShowCloseBtn({ state: true, id: item?.ourID });
                                        } else {
                                            setShowBOImagePageID(item?.ourID);
                                        }
                                    }}>
                                    <div className="image-text">
                                        <img src={LabelIcon} alt="" />
                                        <span className="product-count-no">{`${item?.BOtags?.length ?? 0} products`}</span>
                                    </div>
                                </div>
                            )}
                            <img className="sublogoMain" src={item?.brandLogo} alt="" />
                        </ImageListItem>
                    );
                })}
            </ImageList>
            {skeletonLoading && (
                <p
                    style={{
                        display: "flex",
                        gap: "16px",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "80vh"
                    }}>
                    <img src={Loader} alt="" className="spinner-img" />
                    <div style={{ fontSize: "16px", fontWeight: 600, color: "rgba(255, 255, 255, 1)" }}>Loading please wait...</div>
                </p>
            )}
        </Box>
    );
};

/* #endregion */
/* #region SMALL COMPONENTS */
const RecentlyViewedBtn = ({
    active,
    setSkeletonLoding,
    getFeedRequest,
    storedData,
    setSelectedBrandID,
    setIsRecentBtnClicked,
    isShow
}) => {
    return (
        <div
            className={`feedIcon ${active ? "active" : ""}`}
            style={{ cursor: "pointer", width: "120px", padding: "0px 10px" }}
            onClick={() => {
                if (!active) {
                    setSkeletonLoding(true);
                    setSelectedBrandID("-");
                    setIsRecentBtnClicked(true);
                }
            }}>
            <span>
                <img src={Solid} alt="" style={{ width: "16px" }} />
            </span>
            &nbsp;
            <div
                style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#FFFFFF",
                    display: "flex",
                    textAlign: "center"
                }}>
                Recently Viewed
            </div>
        </div>
    );
};
const Beacon = ({ i, item, targetImageRef, setSelectedHomePageBotagId, setIsShowCloseBtn, selectedType, setShowBOPicpageID }) => {
    const navigate = useNavigate();
    const handleBOImagePin = botag => {
        setSelectedHomePageBotagId(botag?.GTINbarcode);
        if (selectedType === "Posts") {
            navigate(`/${item?.ourID}`);
        } else {
            setShowBOPicpageID(item?.ourID);
            navigate(`/pic/${item?.ourID}`, { replace: true });
        }

        setIsShowCloseBtn({ state: false, id: "" });
    };
    return (
        <div
            className="beacons"
            style={{
                left: i?.beaconXposition * (targetImageRef?.current?.clientWidth / targetImageRef?.current?.naturalWidth) - 20 + "px",
                top: i?.beaconYposition * (targetImageRef?.current?.clientHeight / targetImageRef?.current?.naturalHeight) - 15 + "px"
            }}
            onClick={() => {
                handleBOImagePin(i);
                //navigate(`/${item?.ourID}`);
            }}>
            <div className="beacon-main-div">
                <div
                    style={{
                        backgroundColor: "#FFFFFF",
                        height: "20px",
                        width: "20px",
                        borderRadius: "50%"
                    }}></div>
            </div>
            {i?.productType && <div className="beacon-product-name">{i?.productType}</div>}
        </div>
    );
};
/* #endregion SMALL COMPONENTS */
